export default __webpack_public_path__ + "static/media/user-icon-grey.5ab7fc4e.svg";